"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ListBox = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var SelectionProvider_1 = require("../../provider/SelectionProvider");
var ListBox_module_scss_1 = __importDefault(require("./ListBox.module.scss"));
var getItemsFromKeys = function (items, keys) {
    var itemKeys = Array.from(keys);
    return itemKeys.reduce(function (acc, itemKey) {
        var item = items.getItem(itemKey);
        return item ? __spreadArray(__spreadArray([], acc, true), [item], false) : acc;
    }, []);
};
var ListBox = function (_a) {
    var children = _a.children;
    var _b = (0, SelectionProvider_1.useSelectionContext)(), listBoxProps = _b.listBoxProps, listRef = _b.listRef, selectionState = _b.selectionState;
    var _c = (0, react_1.useState)(false), isOverflown = _c[0], setIsOverflown = _c[1];
    (0, react_1.useEffect)(function () {
        var listElement = listRef.current;
        if (!listElement) {
            return;
        }
        setIsOverflown(listElement.scrollHeight > listElement.clientHeight);
    }, [listRef]);
    var items = selectionState.collection, disabledKeys = selectionState.disabledKeys, selectedKeys = selectionState.selectionManager.selectedKeys;
    var disabledItems = getItemsFromKeys(items, disabledKeys);
    var selectedItems = getItemsFromKeys(items, selectedKeys);
    var unselectedItems = Array.from(items).filter(function (item) { return !disabledKeys.has(item.key) && !selectedKeys.has(item.key); });
    var allItems = Array.from(items);
    var hasNoItems = allItems.length === 0;
    var _d = (0, react_1.useState)({
        selectedItems: selectedItems,
        unselectedItems: unselectedItems,
        disabledItems: disabledItems,
        allItems: allItems,
        hasNoItems: hasNoItems
    }), itemsState = _d[0], setItemsState = _d[1];
    // Only update rendering of items when filtering.
    // Avoids re-ordering of items when making a selection
    (0, react_1.useEffect)(function () {
        setItemsState({
            selectedItems: selectedItems,
            disabledItems: disabledItems,
            unselectedItems: unselectedItems,
            allItems: allItems,
            hasNoItems: hasNoItems
        });
    }, [selectionState.collection.size]);
    if (hasNoItems) {
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement("div", { className: ListBox_module_scss_1["default"].noResultsWrapper }, children(itemsState)),
            react_1["default"].createElement("ul", { ref: listRef, className: ListBox_module_scss_1["default"].hidden })));
    }
    return (react_1["default"].createElement("ul", __assign({}, listBoxProps, { ref: listRef, className: (0, classnames_1["default"])(ListBox_module_scss_1["default"].listBox, isOverflown && ListBox_module_scss_1["default"].overflown) }), children(itemsState)));
};
exports.ListBox = ListBox;
exports.ListBox.displayName = "ListBox";
//# sourceMappingURL=ListBox.js.map